module.exports = __webpack_public_path__ + "img/nanning.1fdaa8c8.png";